(window.AGAStickyLabels = function ($, Behaviors) {
    /**
     * Adds sticky labels to an entire form.
     */
    function AGAStickyLabels() {
        Behaviors.init(AGAStickyLabels, this, arguments);

        this.$fields = this.$elem.find("li.gfield");
        this.$fields.each(function (index, felem) {
            var $felem = $(felem);

            $felem.on("click change focus keydown", this.field_change_intent.bind(this, index, $felem));
            $felem.find("input, textarea").on("blur", this.field_change_intent.bind(this, index, $felem));
            this.field_change_intent(index, $felem);
        }.bind(this));
    }

    Behaviors.inherit(AGAStickyLabels, Behaviors.Behavior);

    AGAStickyLabels.QUERY = "[data-agastickylabels]";

    /**
     * Event handler for when a field is changed.
     * 
     * `field_id` and `$field` should be the number and field element,
     * respectively, you should consider binding them.
     */
    AGAStickyLabels.prototype.field_change_intent = function(field_id, $field) {
        var $input = $field.find("input, textarea"),
            $label = $field.find("label"),
            is_filled = $input.val() !== "",
            is_focused = $input.is(":focus");

        if (is_filled || is_focused) {
            $label.addClass("is-FormItem-sticky_label--stick");
            $label.removeClass("is-FormItem-sticky_label--unstick");
        } else {
            $label.removeClass("is-FormItem-sticky_label--stick");
            $label.addClass("is-FormItem-sticky_label--unstick");
        }
    }

    Behaviors.register_behavior(AGAStickyLabels);

    return AGAStickyLabels;
}(window.jQuery, window.Behaviors));